var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxBoldWallet3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 14.682c0 .56-.46 1.02-1.03 1.02h-1.93c-1.08 0-2.07-.79-2.16-1.87-.06-.63.18-1.22.6-1.63.37-.38.88-.6 1.44-.6h2.05c.57 0 1.03.46 1.03 1.02v2.06z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.43 11.128c.64-.65 1.53-1.03 2.49-1.03h.57c.28 0 .51-.23.47-.51A4.008 4.008 0 0 0 16 6.148H6c-2.21 0-4 1.79-4 4v7c0 2.21 1.79 4 4 4h10a4 4 0 0 0 3.96-3.44c.04-.28-.19-.51-.47-.51h-.45c-1.9 0-3.5-1.42-3.66-3.24-.09-1.05.29-2.08 1.05-2.83zm-9.43.77a.749.749 0 1 1 0-1.5h6c.41 0 .75.34.75.75s-.34.75-.75.75H7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.86 4.652H6.03c-1.09 0-2.11.32-2.96.87-.39.25-.92-.02-.73-.45a3.675 3.675 0 0 1 3.38-2.22h5.62c1.16 0 2.19.41 2.87 1.13.26.27.03.67-.35.67z",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldWallet3);
export default __webpack_public_path__ + "static/media/vuesax-bold-wallet-3.d8c4064fd17561bb1ec4a85cbdba89b6.svg";
export { ForwardRef as ReactComponent };